import { FC, memo } from 'react'

import { CircularProgress } from 'ui/components'

import { DetailsPage } from './components'
import { useDetails } from './useDetails'

const InternalTransferDetails: FC = memo(() => {
  const { data, isFetching, cancelInternalTransfer, CancelConfirmation, pagination } = useDetails()

  if (isFetching && !data) {
    return <CircularProgress centered />
  }

  // Don't render page until filter contains values returned from API.
  if (data?.form.historyPage === null) {
    return null
  }

  return (
    <>
      <CancelConfirmation />
      {data !== undefined && <DetailsPage data={data} onCancel={cancelInternalTransfer} pagination={pagination} />}
    </>
  )
})

export default InternalTransferDetails
